import * as React from 'react'
import { observer } from 'mobx-react'
import styles from '../../styles.sass'
import { Form, TextInputContainer } from 'components/inputs'
import ButtonCollection from 'components/ButtonCollection'
import Button from 'components/Button'
import WorkspaceSignupState from '../WorkspaceSignupState'
import { Env } from 'infra/env'
import { extractMessageFromError } from 'utils/error-util'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  workspaceSignupState: WorkspaceSignupState
}

export default observer(function WorkspaceSearchView({
  workspaceSignupState,
}: Props) {
  return (
    <div className={styles.content}>
      <Form className={styles.inputGroup}>
        <TextInputContainer
          staticText={`.${Env.ORIGIN_WORTAL}`}
          label="Workspace Slug"
          error={workspaceSignupState.fetchWorkspace.match({
            pending: () => undefined,
            rejected: (error: unknown) => extractMessageFromError(error),
            resolved: () => undefined,
          })}
          disabled={workspaceSignupState.fetchWorkspace.pending}
          className={styles.input}
          model={workspaceSignupState}
          field="slug"
          placeholder="Workspace"
        />
        <ButtonCollection>
          <Button
            type="primary"
            disabled={!workspaceSignupState.canSearchWorkspace}
            onClick={() =>
              workspaceSignupState.canSearchWorkspace &&
              workspaceSignupState.fetchWorkspace()
            }
          >
            Continue
          </Button>
        </ButtonCollection>
      </Form>
    </div>
  )
})
